webpackJsonp([184367332820369],{

/***/ 1028:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(72);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _semanticUiReact = __webpack_require__(568);
	
	var _reactHelmet = __webpack_require__(129);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Products = __webpack_require__(494);
	
	var _Products2 = _interopRequireDefault(_Products);
	
	var _Footer = __webpack_require__(259);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Carousel = __webpack_require__(577);
	
	var _Carousel2 = _interopRequireDefault(_Carousel);
	
	__webpack_require__(505);
	
	__webpack_require__(506);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import logoWhite from '../../assets/logo-wht.png';
	
	// example:
	// activeFilters = ['home collection', '']
	
	var Catalog = function (_Component) {
	  _inherits(Catalog, _Component);
	
	  function Catalog() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Catalog);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      filteredProducts: undefined,
	      activeFilters: [],
	      filterIndex: 0,
	      activeFilterIndex: -1
	    }, _this.handleFilterClick = function (e, titleProps) {
	      var index = titleProps.index;
	      var activeFilterIndex = _this.state.activeFilterIndex;
	
	      var newIndex = activeFilterIndex === index ? -1 : index;
	
	      _this.setState({ activeFilterIndex: newIndex });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Catalog.prototype.filterProductsByType = function filterProductsByType(productType) {
	    var _this2 = this;
	
	    // add the loading css
	    return this.props.client.product.fetchQuery({ sortKey: "PRODUCT_TYPE", query: productType }).then(function (products) {
	      //remove the loading css
	      _this2.setState({
	        filteredProducts: products
	      });
	    });
	  };
	
	  Catalog.prototype.componentDidMount = function componentDidMount() {
	    //TODO: re- fetch products after every load
	
	    // add different page style
	    document.querySelector(".footer__links").classList.add("catalog");
	    document.querySelector(".footer__quote").classList.add("catalog");
	    document.querySelector(".sideBar").classList.add("catalog");
	    document.querySelector(".sideBar__btn").classList.add("catalog");
	    document.querySelectorAll("li.topBar__link a").forEach(function (el) {
	      return el.classList.add("catalog");
	    });
	
	    this.props.handleCartClose();
	  };
	
	  Catalog.prototype.render = function render() {
	    var typeOptions = [];
	    //find all the product types and filter to remove duplicates
	    var productTypes = this.props.products.map(function (product) {
	      return product.productType;
	    }).filter(function (val, index, self) {
	      return self.indexOf(val) === index;
	    }).map(function (type) {
	      return _react2.default.createElement(
	        "li",
	        { key: type },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: window.location.pathname + "/" + type },
	          type
	        )
	      );
	    });
	
	    var activeFilterIndex = this.state.activeFilterIndex;
	
	    return _react2.default.createElement(
	      "div",
	      null,
	      _react2.default.createElement(_reactHelmet2.default, {
	        title: "Mile High Boys Club | Catalog",
	        meta: [{
	          name: "description",
	          content: "Mile High Boys Club official website and merch store. Browse our catalog"
	        }, {
	          name: "keywords",
	          content: "Mile High Boys Club, MHBC, MHBC Fashion, fashion"
	        }]
	      }),
	      _react2.default.createElement(
	        "header",
	        { id: "catalogHeader" },
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(_Carousel2.default, null)
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "catalogHeader__textHeader" },
	          _react2.default.createElement(
	            "h1",
	            null,
	            "Catalog"
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "catalogCategory" },
	        _react2.default.createElement(
	          "h2",
	          null,
	          _react2.default.createElement(
	            "span",
	            null,
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: "/" },
	              "Home"
	            ),
	            " \u2192 Catalog"
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            this.props.products.length,
	            " results",
	            _react2.default.createElement("span", null)
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "main",
	        { id: "catalogMain" },
	        _react2.default.createElement(
	          "div",
	          { className: "catalogFilter" },
	          _react2.default.createElement(
	            "div",
	            { className: "filter" },
	            _react2.default.createElement(
	              _semanticUiReact.Accordion,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Accordion.Title,
	                {
	                  active: activeFilterIndex === 1,
	                  index: 1,
	                  onClick: this.handleFilterClick
	                },
	                _react2.default.createElement(
	                  "label",
	                  null,
	                  "Filter By"
	                ),
	                _react2.default.createElement(_semanticUiReact.Icon, { name: "dropdown" })
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Accordion.Content,
	                { active: activeFilterIndex === 1 },
	                _react2.default.createElement(
	                  "ul",
	                  null,
	                  productTypes
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_Products2.default, {
	          products: this.state.filteredProducts ? this.state.filteredProducts : this.props.products,
	          client: this.props.client,
	          addVariantToCart: this.addVariantToCart
	        })
	      ),
	      _react2.default.createElement(_Footer2.default, null)
	    );
	  };
	
	  return Catalog;
	}(_react.Component);
	
	exports.default = Catalog;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-catalog-index-en-js-c799d2c7cfcf5dc17857.js